import React, {PureComponent} from "react"

import {ButtonRouterLink} from "@irati/ui/src/Link"
import id from "@irati/utils/id"
import {hangPromise} from "@irati/utils/promise"
import FormattedMessage from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"

import {Container, StyledH4} from "../../styled"
import {OnDealSubmit} from "../../../../../containers/DealInfo"

interface Props {
  redeemHeaderEmoji?: string
  onClickRedeem: OnDealSubmit
}

interface State {
  load?: Promise<void> | null
  submit?: Promise<any> | null
}

class PerkAvailableBlock extends PureComponent<Props, State> {
  static defaultProps = {
    redeemHeaderEmoji: ""
  }

  state: State = {
    load: hangPromise()
  }

  componentDidMount = () => {
    setTimeout(() => {
      this.setState({load: Promise.resolve()})
    }, 1000)
  }

  handleSubmit = () => {
    const submit = this.props.onClickRedeem().then(() => {
      return hangPromise()
    })
    this.setState({submit})
  }

  render() {
    const {redeemHeaderEmoji, onClickRedeem} = this.props
    const {submit} = this.state

    return (
      <Container>
        <Loading load={this.state.load}>
          <StyledH4 marginBottom={2}>
            {redeemHeaderEmoji} <FormattedMessage id="perks.redemptionEvents.timeToRedeemBlock.header" />
          </StyledH4>
          <ButtonRouterLink id={id("getThisPerk", this.props)} primary large full async onClick={onClickRedeem} load={submit}>
            <FormattedMessage id="perks.containers.dealImportantInfo.getPerk" />
          </ButtonRouterLink>
        </Loading>
      </Container>
    )
  }
}

export default PerkAvailableBlock
